import type { PropsWithChildren } from 'react';
import { useContext, createContext } from 'react';

import type { getClientEnv } from '~/env.mjs';

export type EnvsContextType = ReturnType<typeof getClientEnv>;
type EnvsProviderProps = PropsWithChildren<{ envs: EnvsContextType }>;

const EnvsContext = createContext<EnvsContextType>({} as EnvsContextType);
export const EnvsProvider = ({ envs, children }: EnvsProviderProps) => (
  <EnvsContext.Provider value={envs}>{children}</EnvsContext.Provider>
);

export const useEnvs = () => {
  const context = useContext(EnvsContext);
  return context;
};
